export const COMPONENT_NAME = 'ElDescriptionsItem'
